import { IEntity } from "./Entity";
import { IUser } from "./User";
import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IEntityContributors } from "./EntityContributors";
import { IRiskAppIncident } from "./RiskAppIncident";

export interface IRiskAppIncidentAction extends IEntityWithStatus, IEntityContributors {

    IncidentID?: number;
    Description?: string;
    ActionOwnerID?: number;
    ActualStartDate?: Date | null;
    TargetCompletionDate?: Date | null;
    StageID?: number;
    EntityCreatedOn?: Date | null;
    EntityModifiedOn?: Date | null;
    ActionOwner?: IUser;
    Incident?: IRiskAppIncident;
    Stage?: IEntity;
}

export class RiskAppIncidentAction extends EntityWithStatus implements IRiskAppIncidentAction {

    public IncidentID = null;
    public Description = null;
    public ActionOwnerID = null;
    public ActualStartDate = null;
    public TargetCompletionDate = null;
    public StageID = null;
    public EntityCreatedOn = null;
    public EntityModifiedOn = null;
    public Contributors = [];

}
